<template>
  <div class="comp-xl-distribution">
    <jw-modal :visible="visible" :ok-loading="data.loading" @ok="recipientOk" @cancel="handleCancel" title-align="start" width="600px" class="recipient">
      <template #title> {{ title }} </template>
      <jw-form :model="data.form" label-align="left" class="recipient-form" ref="personForm" @submit="handleSubmit">
        <jw-form-item
          field="persons"
          class="recipient-form-item form-label-text"
          :rules="[
            { required: true, message: $t('请选择接收人员') },
            { maxLength: 1, message: $t('只能选择一个接收人') }
          ]"
          :validate-trigger="['blur', 'input', 'change']"
        >
          <template #label>
            <xl-label-text :value="$t('接收人')" :row="1" />
          </template>

          <fh-person position="bl" :item="{}" :multiple="false" @cb="getMemberRange"> </fh-person>
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { poolClueService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
// import SelectMemberByList from '@/views/setting/components/select-member-by-list/index.vue';

const emits = defineEmits(['cb', 'cancel']);

const { t } = useI18n();
console.log('1-开始创建组件-setup');

const data = reactive({
  poolId: '',
  loading: false,
  businessIds: '', //线索id集合
  form: {
    persons: [],
    transferCause: '',
    cluePool: '',
    memberRange: '',
    relationBusinessIds: [] //转移其他负责人
  }
});
const personForm = ref(null);
const visible = ref(false);
const title = ref('');
// const isSelectMember = ref(false);

const memberUser = ref([]);
const memberRangeUser = ref([]);
const memberRangeDepartment = ref([]);
const memberDepartment = ref([]);

const initFormData = async () => {
  try {
    const json = await poolClueService.getPoolDepartAndUser({
      poolId: data.poolId
    });
    if (!json.error) {
      memberUser.value = json.result.userList;
      memberDepartment.value = json.result.departList;
      console.log('json', json);
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log(e);
  }
};

const transferShow = (record) => {
  memberRangeUser.value = [];
  memberRangeDepartment.value = [];
  data.form.persons = [];
  data.checkedAll = false;
  data.businessIds = record.businessIds;
  data.poolId = record.poolId;
  title.value = record.title;
  personForm.value?.resetFields();
  initFormData();
  visible.value = true;
  console.log();
};

const getMemberRange = (val) => {
  data.form.persons = val?.userList;
};

// 取消按钮
const handleCancel = () => {
  visible.value = false;
};

const recipientOk = () => {
  personForm.value.handleSubmit();
};

const updateFollowUser = async () => {
  data.loading = true;
  try {
    const params = {
      businessIds: data.businessIds,
      id: data.form?.persons[0]?.id,
      poolId: data.poolId
    };
    const json = await poolClueService.poolDistribute(params);
    if (!json.error) {
      Message.success(t('操作成功'));
      emits('cb');
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
    data.loading = false;
    handleCancel();
  } catch (e) {
    data.loading = false;
    console.log(e);
  }
};

const handleSubmit = ({ values, errors }) => {
  console.log('转移接口', values, errors);

  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    personForm.value.setFields(errorArray);
    return;
  }
  updateFollowUser();

  console.log('提交');
};

defineExpose({ transferShow });
</script>
<style scoped lang="less">
@import './xl-distribution.less';
</style>
